import { Component, OnInit, Input } from '@angular/core';
import { TableHandler } from '../../../../../../../classes';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: '[range-dropdown-y]',
  templateUrl: './range-dropdown-y.component.html',
  styleUrls: ['./range-dropdown-y.component.scss']
})
export class RangeDropdownYComponent implements OnInit {
  @Input() table:TableHandler;
  @Input() tableFormGroup:FormGroup;
  min:number = 1;
  max:number = 20;
  constructor() { }

  yLength:FormControl;
  ngOnInit() {
    this.yLength = new FormControl(this.table.yLength, [Validators.min(this.min), Validators.max(this.max)]);
    if (this.tableFormGroup) this.tableFormGroup.setControl('xLength', this.yLength);
  }
  setYLength (v:number) {
    this.table.yLength = v;
    this.yLength.setValue(v);
  }

}
